// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1VEdh","right":"styles_right__2f_9e"};